import { epicRequest, serverResponse } from 'app'

import { authFetch } from '../actions/AuthActions'

export const USER_SETTINGS_FETCH = 'USER_SETTINGS_FETCH'
export const USER_SETTINGS_FETCH_ERROR = 'USER_SETTINGS_FETCH_ERROR'
export const USER_SETTINGS_FETCH_FULFILLED = 'USER_SETTINGS_FETCH_FULFILLED'
export const USER_SETTINGS_FETCH_CANCELED = 'USER_SETTINGS_FETCH_CANCELED'

export const USER_SETTINGS_BANNER_ADD = 'USER_SETTINGS_BANNER_ADD'
export const USER_SETTINGS_BANNER_ADD_ERROR = 'USER_SETTINGS_BANNER_ADD_ERROR'
export const USER_SETTINGS_BANNER_ADD_FULFILLED = 'USER_SETTINGS_BANNER_ADD_FULFILLED'
export const USER_SETTINGS_BANNER_ADD_CANCELED = 'USER_SETTINGS_BANNER_ADD_CANCELED'

export const USER_SETTINGS_AVATAR_ADD = 'USER_SETTINGS_AVATAR_ADD'
export const USER_SETTINGS_AVATAR_ADD_ERROR = 'USER_SETTINGS_AVATAR_ADD_ERROR'
export const USER_SETTINGS_AVATAR_ADD_FULFILLED = 'USER_SETTINGS_AVATAR_ADD_FULFILLED'
export const USER_SETTINGS_AVATAR_ADD_CANCELED = 'USER_SETTINGS_AVATAR_ADD_CANCELED'

export const USER_SETTINGS_UPDATE = 'USER_SETTINGS_UPDATE'
export const USER_SETTINGS_UPDATE_ERROR = 'USER_SETTINGS_UPDATE_ERROR'
export const USER_SETTINGS_UPDATE_FULFILLED = 'USER_SETTINGS_UPDATE_FULFILLED'
export const USER_SETTINGS_UPDATE_CANCELED = 'USER_SETTINGS_UPDATE_CANCELED'

export const USER_CODE_RENEW = 'USER_CODE_RENEW'
export const USER_CODE_RENEW_ERROR = 'USER_CODE_RENEW_ERROR'
export const USER_CODE_RENEW_FULFILLED = 'USER_CODE_RENEW_FULFILLED'
export const USER_CODE_RENEW_CANCELED = 'USER_CODE_RENEW_CANCELED'

export const getInitialState = () => serverResponse({ code: serverResponse() })

export const userSettingsFetch = (userId) => ({
  payload: {
    userId,
  },
  type: USER_SETTINGS_FETCH,
})

export const userSettingsFetchFulfilled = (payload) => ({
  payload,
  type: USER_SETTINGS_FETCH_FULFILLED,
})

export const userSettingsFetchError = (payload) => ({
  payload,
  type: USER_SETTINGS_FETCH_ERROR,
})

export const userSettingsFetchCanceled = () => ({
  payload: null,
  type: USER_SETTINGS_FETCH_CANCELED,
})

export const userSettingsFetchEpic = epicRequest({
  actionType: USER_SETTINGS_FETCH,
  errorAction: userSettingsFetchError,
  fulfilledAction: userSettingsFetchFulfilled,
  request: 'user/settings',
  untilTypes: USER_SETTINGS_FETCH_CANCELED,
})

export const userSettingsUpdate = (settings) => ({
  payload: {
    settings,
  },
  type: USER_SETTINGS_UPDATE,
})

export const userSettingsUpdateFulfilled = (payload) => ({
  payload,
  type: USER_SETTINGS_UPDATE_FULFILLED,
})

export const userSettingsUpdateError = (payload) => ({
  payload,
  type: USER_SETTINGS_UPDATE_ERROR,
})

export const userSettingsUpdateCanceled = () => ({
  payload: null,
  type: USER_SETTINGS_UPDATE_CANCELED,
})

export const userSettingsUpdateEpic = epicRequest({
  actionType: USER_SETTINGS_UPDATE,
  errorAction: userSettingsUpdateError,
  fulfilledAction: userSettingsUpdateFulfilled,
  request: ({ payload }) => {
    const settings = {}

    Object.entries(payload.settings).forEach(([key, value]) => {
      if (['alias', 'blurb', 'first_name', 'height', 'last_name', 'nin', 'phone', 'username', 'weight'].includes(key)) {
        settings[key] = value
      }
    })

    settings.password = payload.settings.pass
    settings.password_actual = payload.settings.passActual
    settings.password_confirm = payload.settings.passConfirm
    settings.key_code = payload.settings.keyCode

    return {
      body: settings,
      method: 'put',
      url: `user/${payload.settings.deleteAccount ? 'deleteAccount' : 'settings'}`,
    }
  },
  untilTypes: USER_SETTINGS_UPDATE_CANCELED,
})

export const userBannerAdd = (image) => ({
  payload: {
    image,
  },
  type: USER_SETTINGS_BANNER_ADD,
})

export const userBannerAddFulfilled = (payload) => ({
  payload,
  type: USER_SETTINGS_BANNER_ADD_FULFILLED,
})

export const userBannerAddError = (payload) => ({
  payload,
  type: USER_SETTINGS_BANNER_ADD_ERROR,
})

export const userBannerAddCanceled = () => ({
  payload: null,
  type: USER_SETTINGS_BANNER_ADD_CANCELED,
})

export const userBannerAddEpic = epicRequest({
  actionType: USER_SETTINGS_BANNER_ADD,
  errorAction: userBannerAddError,
  fulfilledAction: (response, { payload }) => {
    response.data[0].preview = payload.image
    return userBannerAddFulfilled(response)
  },
  maps: [() => authFetch()],
  request: ({ payload }) => {
    const formData = new FormData()

    formData.append('picture', payload.image)

    return {
      body: formData,
      method: 'post',
      url: 'user/picture',
    }
  },
  untilTypes: USER_SETTINGS_BANNER_ADD_CANCELED,
})

export const userAvatarAdd = (image) => ({
  payload: {
    image,
  },
  type: USER_SETTINGS_AVATAR_ADD,
})

export const userAvatarAddFulfilled = (payload) => ({
  payload,
  type: USER_SETTINGS_AVATAR_ADD_FULFILLED,
})

export const userAvatarAddError = (payload) => ({
  payload,
  type: USER_SETTINGS_AVATAR_ADD_ERROR,
})

export const userAvatarAddCanceled = () => ({
  payload: null,
  type: USER_SETTINGS_AVATAR_ADD_CANCELED,
})

export const userAvatarAddEpic = epicRequest({
  actionType: USER_SETTINGS_AVATAR_ADD,
  errorAction: userAvatarAddError,
  fulfilledAction: (response, { payload }) => {
    response.data[0].preview = payload.image
    return userAvatarAddFulfilled(response)
  },
  maps: [() => authFetch()],
  request: ({ payload }) => {
    const formData = new FormData()

    formData.append('avatar', payload.image)

    return {
      body: formData,
      method: 'post',
      url: 'user/avatar',
    }
  },
  untilTypes: USER_SETTINGS_AVATAR_ADD_CANCELED,
})

export const userCodeRenew = () => ({
  type: USER_CODE_RENEW,
})

export const userCodeRenewFulfilled = (payload) => ({
  payload,
  type: USER_CODE_RENEW_FULFILLED,
})

export const userCodeRenewError = (payload) => ({
  payload,
  type: USER_CODE_RENEW_ERROR,
})

export const userCodeRenewCanceled = () => ({
  payload: null,
  type: USER_CODE_RENEW_CANCELED,
})

export const userCodeRenewEpic = epicRequest({
  actionType: USER_CODE_RENEW,
  errorAction: userCodeRenewError,
  fulfilledAction: userCodeRenewFulfilled,
  request: {
    method: 'post',
    url: 'auth/password/code',
  },
  untilTypes: USER_CODE_RENEW_CANCELED,
})
